module.exports = __webpack_public_path__ + "media/images/animations/wide_loads/5-d7dfd7c5af66ccbd7f448c8cffdbe595.png";